import classNames from 'classnames'
import Title from '../../common-components/Title'
import { FontSize } from '../../common-types'
import {
  StrapiV4FAQs,
  TPropsFAQMolecule,
} from '../../molecules-components/faqs'
import { generateSlug } from '@/root/utils/tableOfContent-utils'

type TProps = {
  faq_section: TPropsFAQMolecule & {
    heading?: string
  }
  addFontSize?: FontSize
  addScrollId?: boolean
  json_placeholder?: object
  variant?: 'v0' | 'v1'
  faqClassName?: string
}

const faqSchema = {
  itemScope: true,
  itemType: 'https://schema.org/FAQPage',
}

export function StrapiV4SectionFAQs(props: TProps) {
  const {
    faq_section,
    addFontSize = 'size-34',
    addScrollId,
    json_placeholder = {},
    variant = 'v1',
    faqClassName,
  } = props

  return (
    <div
      id={
        addScrollId && faq_section.heading
          ? generateSlug(faq_section.heading)
          : ''
      }
    >
      {faq_section.heading && (
        <Title
          fontSize={addFontSize}
          headingType="h2"
          className={classNames('text-brand-black ', {
            'text-center font-semibold': variant === 'v0',
            'border-b-1 pb-2.5 font-medium tracking-[0.2px] lg:pb-6':
              variant === 'v1',
          })}
        >
          {faq_section.heading}
        </Title>
      )}
      <div className={classNames('pb-6 lg:pb-12', faqClassName)} {...faqSchema}>
        <StrapiV4FAQs
          faqs={faq_section.faqs}
          json_placeholder={json_placeholder}
          variant={variant}
        />
      </div>
    </div>
  )
}
